import { BotonExportarExcel, Group, Table, Tbody, Td, Text, Th, Thead, Tr } from "@/components/ui";
import type { IndicadorImpuesto } from "@/lib/types";
import { IndicadorRow } from "./IndicadorRow";

/** Tabla del catálogo (corto, sin paginar) · cada fila controla su modo edición. */
export function IndicadoresTable({ indicadores }: { indicadores: IndicadorImpuesto[] }) {
  return (
    <div className="overflow-x-auto">
      <Group justify="flex-end" className="mb-2">
        <BotonExportarExcel
          archivo="indicadores-impuesto"
          hoja="Indicadores"
          filas={indicadores}
          columnas={[
            { header: "Código", value: (i) => i.codigo },
            { header: "Tasa o cuota", value: (i) => i.tasaOCuota },
            { header: "Descripción", value: (i) => i.descripcion },
            { header: "Estado", value: (i) => (i.activo ? "Activo" : "Inactivo") },
          ]}
        />
      </Group>
      <Table verticalSpacing="sm">
        <Thead>
          <Tr>
            <Th>Código</Th>
            <Th>Tasa o cuota</Th>
            <Th>Descripción</Th>
            <Th>Estado</Th>
            <Th />
          </Tr>
        </Thead>
        <Tbody>
          {indicadores.map((i) => (
            <IndicadorRow key={i.id} indicador={i} />
          ))}
          {indicadores.length === 0 && (
            <Tr>
              <Td colSpan={5}>
                <Text size="sm" c="dimmed" ta="center" className="py-3">
                  Sin indicadores. Crea el primero con "Nuevo indicador".
                </Text>
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </div>
  );
}
